export default __webpack_public_path__ + "static/media/routeview.6c5db6fb.png";